/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OptInMessages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OptInMessages({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/OptInMessages",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsConsentOptinValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'consentOptin',
format: fromHelpers.getValueConsent,
})
let settingsConsentOptinChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'consentOptin',
})
let settingsMarketingOptinValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'marketingOptin',
format: fromHelpers.getValueMarketing,
})
let settingsMarketingOptinChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'marketingOptin',
})
  return (<React.Fragment
>
<div
  data-testid="OptInMessages.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1s88Bi': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 backgroundColor="white"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Consent Opt-in Message"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 height={160}
 data="settings.consentOptin"
 format="helpers.js getValueConsent"
 onChange={settingsConsentOptinChangeData}
 value={settingsConsentOptinValueData}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 backgroundColor="white"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Marketing Opt-in Message"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 height={160}
 data="settings.marketingOptin"
 format="helpers.js getValueMarketing"
 onChange={settingsMarketingOptinChangeData}
 value={settingsMarketingOptinValueData}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
</div>
{children}
</React.Fragment>)
}